import React from 'react';

const AppointmentSubHeader: React.FC<{
  isTimeChange?: boolean;
  isListingContact?: boolean;
  isMobile?: boolean;
}> = ({ isTimeChange, isMobile, isListingContact }) => {
  if (isTimeChange && isListingContact) {
    if (isMobile) return <>Suggest Better Date / Time</>;
    return <>Suggest Better Time</>;
  }
  if (isTimeChange) return <>Modify Showing</>;
  return <>Book Showing</>;
};

export default AppointmentSubHeader;
